import { getTableViewSettingsObject } from "../helpers/agGrid";
import { listingStatuses as ls } from "./listingStatuses";
import { getExpiredColumns } from "./listingStatuses/expired";
import { getNewListingsColumns } from "./listingStatuses/newListings";
import { getSoldColumns } from "./listingStatuses/sold";
import { getUnderContractColumns } from "./listingStatuses/underContract";
import { marketDynamicsColumns as mdCols } from "./marketDynamicsColumns";

export const getTableSettingsByStatuses = shouldShowAdditionalInfo => ({
    [ls.newListings.id]: getTableViewSettingsObject(ls.newListings.id, getNewListingsColumns(shouldShowAdditionalInfo), mdCols.listDate.id),
    [ls.forSale.id]: getTableViewSettingsObject(ls.forSale.id, getNewListingsColumns(shouldShowAdditionalInfo), mdCols.listDate.id),
    [ls.underContract.id]: getTableViewSettingsObject(ls.underContract.id, getUnderContractColumns(shouldShowAdditionalInfo), mdCols.ucDate.id),
    [ls.sold.id]: getTableViewSettingsObject(ls.sold.id, getSoldColumns(shouldShowAdditionalInfo), mdCols.soldDate.id),
    [ls.expired.id]: getTableViewSettingsObject(ls.expired.id, getExpiredColumns(shouldShowAdditionalInfo), mdCols.offMarketDate.id),
    [ls.forSaleLdm.id]: getTableViewSettingsObject(ls.forSaleLdm.id, getNewListingsColumns(shouldShowAdditionalInfo), mdCols.listDate.id)
});
